<template>
  <div class="d-flex flex-column align-items-start py-2 px-4">
    <h3 class="font-weight-bold">Restablecer Contraseña</h3>
    <p>Cambia tu contraseña</p>
    <div class="form-group w-100">
      <label for="getPass" class="float-left">Nueva Contraseña</label>
      <input
        type="password"
        class="form-control"
        id="getPass"
        aria-describedby="getPass"
        placeholder="*************"
        v-model="newpassword"
      >
    </div>
    <div class="form-group w-100">
      <label for="getPass2" class="float-left">Repetir Nueva Contraseña</label>
      <input
        type="password"
        class="form-control"
        id="getPass2"
        aria-describedby="getPass2"
        placeholder="*************"
        v-model="verifypassword"
      >
    </div>
    <router-link to="/confirmpass" class="btn btn-primary mt-4 btn-lg btn-block">Continuar</router-link>
  </div>
</template>

<script>
export default {
  name: 'NewPassword',
  data() {
    return {
      newpassword: '',
      verifypassword: ''
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// RestorePassword.vue?7de7e56c